/* File: src/pages/GuestPages/CitySelectionPage.js */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEvent } from '../../contexts/EventContext';
import Button from '../../components/common/Button';
import './CitySelectionPage.css';

const CitySelectionPage = () => {
  const navigate = useNavigate();
  const { setSelectedCity } = useEvent();
  const [selectedCity, setLocalSelectedCity] = useState('');
  const [loading, setLoading] = useState(false);

  // Vérifier que l'utilisateur a bien passé la vérification d'âge
  useEffect(() => {
    const birthYear = localStorage.getItem('birthYear');
    if (!birthYear) {
      navigate('/');
    }
  }, [navigate]);

  const handleCitySelection = (city) => {
    setLocalSelectedCity(city);
  };

  const handleContinue = async () => {
    if (!selectedCity) {
      return;
    }

    setLoading(true);
    
    try {
      // Sauvegarder la ville sélectionnée dans le contexte et localStorage
      setSelectedCity(selectedCity);
      localStorage.setItem('selectedCity', selectedCity);
      
      // Rediriger vers la page de l'événement
      navigate('/event');
    } catch (error) {
      console.error('Erreur lors de la sélection de la ville:', error);
      setLoading(false);
    }
  };

  const handleBack = () => {
    // Retour à la vérification d'âge
    navigate('/');
  };

  return (
    <div className="city-selection-page">
      <div className="city-selection-container">
        <div className="back-arrow" onClick={handleBack}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12H5" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 19L5 12L12 5" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        <div className="city-selection-header">
          <img 
            src="/assets/images/guinness-logo.png" 
            alt="Guinness Cameroun" 
            className="city-selection-logo" 
          />
          <h1>CHOISISSEZ VOTRE VILLE</h1>
          <p>Sélectionnez la ville où vous souhaitez participer à l'événement Guinness Bright Bar</p>
        </div>

        <div className="city-selection-content">
          <div className="cities-grid">
            <div 
              className={`city-card ${selectedCity === 'Bafoussam' ? 'selected' : ''}`}
              onClick={() => handleCitySelection('Bafoussam')}
            >
              <div className="city-icon">
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3>BAFOUSSAM</h3>
              <p className="city-date">5 Juillet 2025</p>
              <p className="city-location">PANAMA AKWA</p>
              {selectedCity === 'Bafoussam' && (
                <div className="city-selected-badge">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M20 6L9 17l-5-5" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              )}
            </div>

            <div 
              className={`city-card ${selectedCity === 'Douala' ? 'selected' : ''}`}
              onClick={() => handleCitySelection('Douala')}
            >
              <div className="city-icon">
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3>DOUALA</h3>
              <p className="city-date">12 Juillet 2025</p>
              <p className="city-location">DREAMS PALACE</p>
              {selectedCity === 'Douala' && (
                <div className="city-selected-badge">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M20 6L9 17l-5-5" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              )}
            </div>
          </div>

          <div className="city-selection-actions">
            <Button
              variant="guinness"
              size="lg"
              fullWidth
              onClick={handleContinue}
              disabled={!selectedCity || loading}
            >
              {loading ? 'CHARGEMENT...' : 'CONTINUER'}
            </Button>
          </div>
        </div>

        <div className="city-selection-footer">
          <p>
            La consommation d'alcool est réservée aux personnes âgées de plus de 21 ans. 
            L'abus d'alcool est dangereux pour la santé, à consommer avec modération.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CitySelectionPage;